<template>
  <div id="players" class="people">
    <section id="wrapper">
      <header>
        <div class="inner">
          <h2>Rosa calciatori</h2>
          <p>Stagione {{ season }}</p>
        </div>
      </header>
      <div class="wrapper">
        <div class="inner">
          <section class="person_list">
            <select name="season" v-model="season">
              <option v-for="(_f, key) in formations" :key="key" :value="key">
                {{ 'Stagione ' + key }}
              </option>
            </select>
            <div class="table-wrapper">
              <table>
                <thead>
                  <tr>
                    <th></th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="p in formations[season]" :key="p.person_id">
                    <td class="person_image">
                      <img
                        :srcset="image_urls(people[p.person_id].image)"
                        :src="image_url(people[p.person_id].image)"
                        :alt="person_name(people[p.person_id])"
                      />
                    </td>
                    <td class="person_info">
                      <b>{{ person_name(people[p.person_id]) }}</b>
                      <br />
                      {{ p.role }}
                      <br />
                      <a
                        v-if="people[p.person_id].url"
                        :href="info_url + people[p.person_id].url"
                        target="_blank"
                        rel="noopener"
                      >
                        <i class="fa fa-info-circle" />info
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useHead } from '@unhead/vue';

import peopleData from '../data/people.json';
import formationsData from '../data/formations.json';
import { usePersonDisplay, info_url } from '../composables/usePersonDisplay';
import { usePeopleIndex } from '../composables/usePeopleIndex';
import type { People, Formations } from '../types';

useHead({ title: 'Squadra' });

const people = usePeopleIndex(peopleData as People);
const formations = formationsData as Formations;

const season = ref(Object.keys(formations)[0] ?? '');

const { image_urls, image_url, person_name } = usePersonDisplay();
</script>

<style scoped>
/* spostare in css condiviso */
.people .wrapper .inner {
  padding: 0.5em;
}
.people select {
  margin-bottom: 2em;
}
.people table td {
  vertical-align: middle;
  padding: 1em 0.5em;
}
.people table td.person_image {
  width: 10em;
}
.people table td.person_image img {
  width: 8em;
}
.people table td.person_info a {
  font-size: 0.8rem;
}
.people table td.person_info a i {
  margin-right: 0.5em;
}

@media (max-width: 480px) {
  .people table td.person_image {
    width: 7em;
  }
  .people table td.person_image img {
    width: 5em;
  }
}
</style>
